
import * as defaultImport from "@splunk/react-icons/TrianglesLayeredDouble";
export * from "@splunk/react-icons/TrianglesLayeredDouble";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
